import InfinityLightVertical_default from "../../../../assets/Images/InfinityLightVertical.png.js";
import InfinityDarkVertical_default from "../../../../assets/Images/InfinityDarkVertical.png.js";
import "react";
import { Image, useAtalayaContext } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/AuthWrapper2/components/Login/Wrapper.tsx
function LoginWrapper({ children }) {
	const { isDarkMode } = useAtalayaContext();
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-lg max-h-full w-3/4 max-w-[32rem]",
		children: [/* @__PURE__ */ jsx("div", {
			className: "flex flex-col items-center",
			children: /* @__PURE__ */ jsx(Image, {
				src: isDarkMode ? InfinityDarkVertical_default : InfinityLightVertical_default,
				fit: "contain",
				width: 350
			})
		}), children]
	});
}
//#endregion
export { LoginWrapper };

//# sourceMappingURL=Wrapper.js.map